import LoginCarousel from "./LoginCarousel";
import LoginBanner from "./LoginBanner";
import LoginForm from "./LoginForm";
import CustomFormMain from "./CustomFormMain";

export default CustomFormMain;